import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { EstadoPadron } from '@shared/enums/estadoPadron';
import { TipoPadron, TipoRegimenARBA } from '@shared/enums/tiposPadron';
import { CargaPadron } from '@shared/models/padrones/CargaPadron';
import { PadronesService } from '../padrones.service';
import { Guid } from "guid-typescript";
import { UsuarioService } from "@account/usuario.service";

@Component({
  selector: 'app-importacion-padrones',
  templateUrl: './importacion-padrones.component.html',
  styleUrls: ['./importacion-padrones.component.css']
})
export class ImportacionPadronesComponent implements OnInit {

  tiposPadron: [TipoPadron, string][] = [
    [TipoPadron.CABA, "CABA"],
    [TipoPadron.ARBAPercepciones, "ARBA Percepciones"],
    [TipoPadron.PercepcionIVARG17, "Percepción IVA RG 17"],
    [TipoPadron.PercepcionIVARG18, "Percepción IVA RG 18"],
    [TipoPadron.Jujuy, "Jujuy"],
    [TipoPadron.Tucuman, "Tucumán"]
  ];
  selectedTipoPadron: [TipoPadron, string];
  mensajeError: string;
  mensajeOk: string;
  guidFile: Guid;
  profileForm: UntypedFormGroup;
  file: File;
  // Nuevas propiedades para los archivos de Jujuy
  fileJujuyPrincipal: File;
  fileJujuyExcluidos: File;
  jujuyPrincipalCargaExitosa: boolean = false;

  EstadoPadron = EstadoPadron;
  TipoRegimenARBA = TipoRegimenARBA;
  TipoPadron = TipoPadron;
  preparandoCarga: boolean;
  tipoRegimenARBA: TipoRegimenARBA;

  constructor(
    private fb: UntypedFormBuilder,
    private padronesService: PadronesService,
    private usuarioService: UsuarioService
  ) { }

  ngOnInit() {
    this.profileForm = this.fb.group({
      inputFile: [''],
      tipoRegimenARBA: ['']
    });
    this.selectedTipoPadron = this.tiposPadron[0];
  }

  // Método para archivo principal de Jujuy
  onSelectedFileJujuyPrincipal(event) {
    if (event.target.files.length === 0) return;

    this.guidFile = Guid.create();

    const originalFile = event.target.files[0];
    // Crear nuevo nombre con prefijo
    const newFileName = 'padronretper_' + originalFile.name;

    // Crear un nuevo File con el nombre modificado
    this.fileJujuyPrincipal = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    this.mensajeError = '';
    this.jujuyPrincipalCargaExitosa = false;
  }

  // Método para archivo de excluídos de Jujuy
  onSelectedFileJujuyExcluidos(event) {
    if (event.target.files.length === 0) return;

    const originalFile = event.target.files[0];
    // Crear nuevo nombre con prefijo
    const newFileName = 'padronretper_excluidos_' + originalFile.name;

    // Crear un nuevo File con el nombre modificado
    this.fileJujuyExcluidos = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    this.mensajeError = '';
  }

  // Método original para otros tipos de padrón
  onSelectedFile(event) {
    if (event.target.files.length === 0) return;

    const file = event.target.files[0];

    if (this.selectedTipoPadron[0] === TipoPadron.Tucuman) {
      const newFileName = 'archivocoefrg116_' + file.name;
      this.file = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    } else {
      this.file = file;
    }

    this.mensajeError = '';
  }

  // Método para determinar si se puede cargar
  puedeCargar(): boolean {
    if (this.selectedTipoPadron[0] === TipoPadron.Jujuy) {
      // Para Jujuy, se requieren ambos archivos
      return (this.fileJujuyPrincipal !== null && !this.jujuyPrincipalCargaExitosa) || (this.fileJujuyExcluidos !== null && this.jujuyPrincipalCargaExitosa);
    } else {
      // Para otros tipos, se requiere el archivo normal
      return this.file !== null;
    }
  }

  get loteCargas(): CargaPadron[] {
    return this.padronesService.loteCargas;
  }

  onSubmit() {
    const responsable = this.obtenerUsuarioLogueado();

    if (this.profileForm.value.tipoRegimenARBA === TipoRegimenARBA.Combustibles) {
      this.selectedTipoPadron[0] = TipoPadron.ARBAPercepcionesCombustibles;
    }
    if (this.selectedTipoPadron[0] === TipoPadron.Jujuy) {
      // Para Jujuy, verificar si es el archivo principal o excluidos
      if (!this.jujuyPrincipalCargaExitosa) {
        // Cargar archivo principal
        this.padronesService.cargarPadronJujuy(
          this.fileJujuyPrincipal,
          this.selectedTipoPadron[0],
          this.guidFile,
          responsable,
        );
        // NO resetear aún, esperar la respuesta
      } else {
        // Cargar archivo de excluidos
        this.padronesService.cargarPadron(
          this.fileJujuyExcluidos,
          responsable,
          this.selectedTipoPadron[0]
        );
        this.reset(); // Ahora sí resetear
      }
    } else {
      this.padronesService.cargarPadron(this.file, responsable, this.selectedTipoPadron[0]);
      this.reset();
    }
  }

  onSelectedTipoPadron(e: [TipoPadron, string]) {
    this.selectedTipoPadron = e;
    // Limpiar las cargas terminadas para ocultar las alertas
    this.padronesService.loteCargas = this.padronesService.loteCargas.filter(
      c => c.tipoPadron !== this.selectedTipoPadron[0]
    );
    this.reset();
  }

  onCancelarCarga(cargaPadron: CargaPadron) {
    this.padronesService.cancelarCarga(cargaPadron);
    this.reset();
  }

  get cargandoPadron(): CargaPadron {
    return this.padronesService.loteCargas.find(cp => cp.tipoPadron == this.selectedTipoPadron[0]
      && (cp.estado === EstadoPadron.Preparando || cp.estado === EstadoPadron.Subiendo || cp.estado === EstadoPadron.Importando));
  }

  get cargaPadronTerminada(): CargaPadron {
    const carga = this.padronesService.loteCargas.find(cp => cp.tipoPadron == this.selectedTipoPadron[0]
      && (cp.estado === EstadoPadron.Cancelado || cp.estado === EstadoPadron.Error || cp.estado === EstadoPadron.Finalizado));
    if (carga)
      this.mensajeError = carga.error;
    return carga;
  }

  get jujuyArchivoExitoso(): boolean {
    const carga = this.padronesService.loteCargas.find(
      cp => cp.tipoPadron === TipoPadron.Jujuy &&
        cp.estado === EstadoPadron.Finalizado
    );
    if (carga) {
      this.jujuyPrincipalCargaExitosa = true;
    }
    return this.jujuyPrincipalCargaExitosa;
  }

  get fileName(): string {
    if (this.file) {
      return this.file.name;
    }
    return '';
  }

  obtenerUsuarioLogueado() {
    return this.usuarioService.getNombresOperador();
  }

  /**
   * Limpiar pantalla
   */
  reset() {
    this.file = null;
    this.fileJujuyPrincipal = null;
    this.fileJujuyExcluidos = null;
    this.mensajeError = null;
    this.jujuyPrincipalCargaExitosa = false;
    this.profileForm.reset();
    if (this.selectedTipoPadron[0] === TipoPadron.ARBAPercepciones ||
      this.selectedTipoPadron[0] === TipoPadron.ARBAPercepcionesCombustibles) {
      this.profileForm.patchValue({ tipoRegimenARBA: TipoRegimenARBA.General })
    }
  }
}
